import React, { useState } from 'react'
import Password from '../Password';
import useUpdatePasswordForLinkedinUsers from '../../../Hooks/Auth/useUpdatePasswordForLinkedinUsers';


const SmallSignupVerify = ({ }) => {
    const [loading, error, success, setNewPassword] = useUpdatePasswordForLinkedinUsers();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const candidateId = new URLSearchParams(window.location.search).get('candidat') || new URLSearchParams(window.location.search).get('candidate');
    const email = new URLSearchParams(window.location.search).get('email');

    
    const submitRequest = async (e) => {
        e.preventDefault();
        try {
            await setNewPassword(password, candidateId, email);
            // goToLoginPage();
        }
        catch (err) {
            // console.log(err);
        }
    }

    if (success) {
        return (
            <div className=' flex flex-col items-center justify-center h-full gap-4 p-4'>
                <h4 className=' font-semibold text-2xl text-center'>Verification Successful!</h4>
                <p>Now <span className='text-blue-500 font-semibold hover:underline cursor-pointer' onClick={() => { window.open('/auth/login', '_self') }}>Login</span> to continue.</p>
            </div>
        )
    }

    return (
        <div className=' w-full flex flex-col md:flex-row'>



            <div className='flex-1 flex flex-col items-center justify-between px-4 py-6  md:w-1/2 md:py-20'>
                <div className='w-full max-w-md md:max-w-lg bg-white-bg-color p-8 rounded-lg shadow-lg'>
                    <h3 className='text-2xl font-bold text-center mb-2 md:text-3xl'>Set Password</h3>
                    <p className='md:block text-text-color-strong text-xs text-center mb-6'>
                        Set a strong new password for your account.
                    </p>

                    <form onSubmit={submitRequest} className='w-full'>
                        <div className='mb-6 space-y-5 md:mb-10'>
                            <label className='block text-sm font-semibold text-[#171717] mb-2'>
                                Password
                            </label>
                            <Password
                                email={password}
                                setPassword={setPassword}
                            // setEmailValid={setEmailValidation}
                            />
                            <label className='block text-sm font-semibold text-[#171717] mb-2'>
                                Confirm Password
                            </label>
                            <Password
                                email={confirmPassword}
                                setPassword={setConfirmPassword}
                            // setEmailValid={setEmailValidation}
                            />
                        </div>

                        <div className='mt-auto pt-20 md:pt-16 w-full'>
                            <button
                                className='w-full text-white-bg-color py-4 px-6 rounded-full font-medium bg-primary-color-900 hover:bg-primary-color-600'
                                type='submit'
                                disabled={loading}
                            >
                                Submit Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default SmallSignupVerify;